import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { ProjectsService } from '../../../../../../core/projects.service';
import { ClearBidSheet } from '../../../../../../core/projects.actions';
import {
  ChangeInWorkRequestSideNavWrapperComponent,
} from '../change-in-work-request-side-nav-wrapper/change-in-work-request-side-nav-wrapper.component';
import { ChangeInWorkRequestService } from '../change-in-work-request.service';
import { MatSelect } from '@angular/material/select';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-change-in-work-request-filters',
    templateUrl: './change-in-work-request-filters.component.html',
    styleUrls: ['./change-in-work-request-filters.component.scss'],
    standalone: false
})
export class ChangeInWorkRequestFiltersComponent implements OnInit, OnDestroy {
  @ViewChild('sortSelect') sortSelect: MatSelect;

  defaultDateValue = 'All time';
  // Approved is split so users can filter to approved requests not yet
  // combined into a change order (values handled in the list's status filter).
  statusOptions = [
    { label: 'Awaiting Submission', value: 'draft', isChecked: false },
    { label: 'Awaiting Approval', value: 'submitted', isChecked: false },
    { label: 'Approved - In change order', value: 'approved-in-co', isChecked: false },
    { label: 'Approved - Not in change order', value: 'approved-not-in-co', isChecked: false },
    { label: 'Rejected', value: 'rejected', isChecked: false },
  ];
  form = new FormGroup({
    searchText: new FormControl(''),
  });
  selectedSortColumn: string | null = 'Request #';
  sortByColumns: string[] = ['Request #', 'Amount change', 'Work days change', 'Status', 'Created at'];
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private store: Store,
    private projectsService: ProjectsService,
    private changeInWorkRequestService: ChangeInWorkRequestService,
  ) {

  }

  ngOnInit() {
    this.form.controls.searchText.valueChanges
      .pipe(debounceTime(200), takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.changeInWorkRequestService.search.next(data);
      });
  }

  createRequest() {
    this.projectsService.openRightPanel.next({
      component: ChangeInWorkRequestSideNavWrapperComponent,
      data: {
        createRequest: true,
        projectId: this.route?.snapshot?.params?.['projectId'],
      },
    });
  }

  search() {
    const { searchText } = this.form.getRawValue();
    this.changeInWorkRequestService.search.next(searchText);
  }

  close() {
    this.form.reset();
    const searchText = '';
    this.changeInWorkRequestService.search.next(searchText);
  }

  openSortDropdown(event?: Event): void {
    // Material renders the select panel and its backdrop as an inline popover
    // *inside* this wrapper, so the click that closes the panel bubbles back
    // here and would reopen it. Only react to clicks on the button itself.
    const target = event?.target as HTMLElement | null;
    if (target?.closest('.cdk-overlay-popover, .cdk-overlay-backdrop')) return;
    this.sortSelect?.open?.();
  }

  onSortColumnChange(event: any): void {
    this.selectedSortColumn = event.value;
    this.changeInWorkRequestService.sort.next({ column: this.selectedSortColumn, direction: 'asc' });
  }

  removeSort(event: Event): void {
    event?.stopPropagation();
    this.selectedSortColumn = null;
    this.changeInWorkRequestService.sort.next({ column: null, direction: 'asc' });
  }

  ngOnDestroy() {
    this.store.dispatch(ClearBidSheet());
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
